<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <el-form label-position="top" label-width="80px" :model="searchForm">
                    <el-row :gutter="30">
                        <el-col :span="10">
                            <el-form-item label="公司/門店">
                                <el-select v-model="searchForm.COMP_ID" placeholder="公司代碼" style="width:100%;" disabled>
                                    <el-option v-for="item in compOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row type="flex" justify="center">
                    <el-col :span="6" style="margin-top:auto;margin-bottom:auto;">
                        <el-button style="width: 100%" type="primary" @click="onSearch" v-show="store.getters.check_auth('SEARCH')">Search</el-button>
                    </el-col>
                </el-row>
            </div>
            <div id="datablock">
                <el-row type="flex" justify="end">
                    <el-button type="primary" round plain @click="onAddClick()" v-show="store.getters.check_auth('ADD')">新增</el-button>
                </el-row>

                <OutletUserTable ref="outletusertableRef"></OutletUserTable>
            </div>

            <!--使用者資料-->
            <OutletUserInfo ref="outletuserRef" @finish="onSearch"></OutletUserInfo>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus';
    import OutletUserTable from '@/components/OutletUserTable.vue'
    import OutletUserInfo from '@/components/OutletUserInfo.vue'
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const showMain = ref(true);//顯示主頁面

    const compOptions = ref([]);

    const outletusertableRef = ref(null);
    const outletuserRef = ref(null);

    const searchForm = reactive({
        COMP_ID: localStorage.getItem('VendorId')
    });

    const form = ref({
        VENDOR_ID: '',
        USER_CODE: '',
        USER_NAME: '',
        EMAIL: '',
        TEL_NO: '',
        ROLE_ID: '',
        ACCT_ENABLE: 'Y',
        PWD_EXPIRY_DATE: '',
        PASSWORD: '',
        PASSWORD_AGAIN: '',
    });

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    const onSearch = () => {
        outletusertableRef.value.onSearch(searchForm);
    };

    const onAddClick = () => {
        outletuserRef.value.onAddClick(searchForm.COMP_ID);
    };


    const getOptions = async () => {
        $api.GET('/api/Outlet/GetCompOptions', {
            CUST_CODE: localStorage.getItem('CustCode'),
            VENDOR_ID: localStorage.getItem('VendorId'),
            ROLE_TYPE: localStorage.getItem('VendorType')
        }).then((response) => {
            compOptions.value = response;
        });
    }

    onBeforeMount(() => {
        //options
        getOptions();
    })
</script>
<style></style>